import { twMerge } from "tailwind-merge";
import { Type } from "./Type";
import { Check } from "lucide-react";

export type Props = {
  isMet: boolean;
  message: string;
  captionClassName?: string;
};

export function RequirementCheck({ isMet, message, captionClassName }: Props) {
  return (
    <div className="flex items-start gap-2">
      <div
        className={twMerge(
          "flex h-4 w-4 items-center justify-center rounded-full text-brand-50 shrink-0 relative top-0.5",
          isMet ? "bg-success" : "bg-brand-400"
        )}
      >
        <Check size={12} />
      </div>
      <Type variant="caption" className={twMerge(captionClassName)}>
        {message}
      </Type>
    </div>
  );
}

export default RequirementCheck;
